import { Router, NavigationStart } from '@angular/router';
import { Injectable, Type } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BreadcrumbRouteData } from '../components/app.breadcrumb';

export interface BreadcrumbSegment {
    data: BreadcrumbRouteData;
    component?: Type<any>;
}

@Injectable({ providedIn: 'root' })
export class BreadcrumbService {
    private _breadcrumbs$ = new BehaviorSubject<BreadcrumbSegment[]>([]);
    readonly breadcrumbs$: Observable<BreadcrumbSegment[]> = this._breadcrumbs$.asObservable();

    constructor(private router: Router) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                this._breadcrumbs$.next([]); // or a default value
            }
        });
    }

    addBreadcrumb(component: Type<any>, data: BreadcrumbRouteData) {
        const segment: BreadcrumbSegment = { data, component };
        const current = this._breadcrumbs$.getValue();
        // Check for an existing segment with the same component
        const exists = current.some(crumb => crumb.component === component);
        if (!exists) {
            this._breadcrumbs$.next([...current, segment]);
        }
        else {
            const updated = current.map(seg => seg.component === component ? segment : seg);
            this._breadcrumbs$.next(updated);
        }
    }
}
